import React from 'react'
import { filterType } from '../../../redux-store/types/api-types';
import { Box, List, ListItem, ListItemText, Modal, SxProps, Typography } from '@mui/material';

type Props = {
    labelData: filterType[];
    data?: Array<Array<string | number>>;
    defaultValue?: filterType,
    isLoading?: boolean;
    open: boolean;
    handleClose: () => void
    title?: string
}

const style: SxProps = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '533px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    borderRadius: '12px',
    height: 'auto',
    maxHeight: 'calc(100% - 200px)',
    overflow: 'auto',
    p: 4,
};

export default function ListModel(props: Props) {

    const { labelData = [], data, defaultValue, isLoading, open, handleClose, title } = props || {}

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={style}>
                {title &&
                    <Typography variant='h5'>{title}</Typography>
                }
                <List dense>
                    {[...labelData]?.map((item, index) =>
                        <ListItem key={index} secondaryAction={
                            <ListItemText>{Number(item?.value)?.toFixed(2)} %</ListItemText>
                        }>
                            <ListItemText>{index + 1 + ")"} {item?.label}</ListItemText>
                        </ListItem>
                    )}
                </List>
            </Box>
        </Modal>
    )
}